type FocusTrapEvent = {
  preventDefault: () => void;
  shiftKey: boolean;
};

export function wrapFocus(
  event: FocusTrapEvent,
  focusable: ArrayLike<HTMLElement>
) {
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}
